import styled from 'styled-components';
import { FlexRow } from '@make-software/tg-mini-app-ui';

export const ButtonWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    margin: '16px 0'
  })
);
